import React from "react";
import { Carousel } from "react-bootstrap";
import MenuInteremedioNiveles from "./menuInteremedioNiveles";
import HomePage from "../homepage";



function proyectoEducativo() {
    return (
        <div id ="texto-proyectoEducativo" style={{ zIndex: 1, paddingTop: "1rem" }}> <MenuInteremedioNiveles />

            <div className="d-flex flex-column justify-content-center align-items-center text-center" data-aos="fade-up">
                <h1 className="text-center display-6 mb-4" style={{ color: "yellow", letterSpacing: "2px" }}>
                    Propuesta Educativa
                </h1>
                <div style={{ maxWidth: "800px" }}>
                    <p className="fs-5">
                        Como Institución Educativa anhelamos ser referencia pedagógico-pastoral, desde un permanente
                        diálogo entre la tradición y la innovación, educando mujeres y varones comprometidos en la
                        construcción de una sociedad más justa y solidaria.
                    </p>
                </div>
                <HomePage></HomePage>
            </div>




        </div>
    );


}

export default proyectoEducativo;
